import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import PoziAPIData from 'api/data'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

import LoaderHandleGeoJSON, { LoaderFailed } from './LoaderHandleGeoJSON'

export default function (layer) {
  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (extent, resolution, projection, success, failure) {
      window.store.dispatch(setLayerLoadInProgress(layer.titleid))
      GetAnnotationsCookie(layer)
        .then(function (geojson) {
          LoaderHandleGeoJSON(geojson, projection, geojsonSource, layer, success)
        })
        .catch(function (err) {
          LoaderFailed(layer, err, failure)
        })
    },
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}

// Get geojson from user generated annotations stored as zipped geojson in a cookie.
function GetAnnotationsCookie (layer) {
  const url = '/config/staging/test.json'

  return PoziAPIData().ajaxAsPromise({
    url,
    timeout: 10000
  })
}
